<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";

const containerRef = ref(null);
let canvas, ctx;
const particles = [];

class Particle {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.vx = Math.random() * 1.5 - 0.75;
    this.vy = Math.random() * 1.5 - 0.75;
  }

  update() {
    this.x += this.vx * 0.3;
    this.y += this.vy * 0.3;

    if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
    if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
  }

  draw() {
    ctx.beginPath();
    ctx.arc(this.x, this.y, 2, 0, Math.PI * 2);
    ctx.fillStyle = "rgb(0, 150, 255)";
    ctx.fill();
  }
}

const getParticleCount = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 576) return 160; // Small screens (phones)
  if (screenWidth < 1024) return 120; // Medium screens (tablets)
  return 80; // Large screens (desktops)
};

const createParticles = () => {
  particles.length = 0;
  const totalParticles = getParticleCount();
  const leftBoundary = canvas.width * 0.3;
  const rightBoundary = canvas.width * 0.7;

  for (let i = 0; i < totalParticles; i++) {
    let x, y;
    if (Math.random() < 0.5) {
      x = Math.random() * leftBoundary;
    } else {
      x = Math.random() * (canvas.width - rightBoundary) + rightBoundary;
    }
    y = Math.random() * canvas.height;
    particles.push(new Particle(x, y));
  }
};

const drawLines = () => {
  ctx.beginPath();
  for (let i = 0; i < particles.length; i++) {
    for (let j = i + 1; j < particles.length; j++) {
      let dx = particles[i].x - particles[j].x;
      let dy = particles[i].y - particles[j].y;
      let distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < 100) {
        ctx.strokeStyle = "rgb(0, 150, 255)";
        ctx.lineWidth = 0.7;
        ctx.moveTo(particles[i].x, particles[i].y);
        ctx.lineTo(particles[j].x, particles[j].y);
      }
    }
  }
  ctx.stroke();
};

const animate = () => {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  particles.forEach((p) => {
    p.update();
    p.draw();
  });
  drawLines();
  requestAnimationFrame(animate);
};

const resizeCanvas = () => {
  const container = containerRef.value;
  if (canvas) {
    const ratio = window.devicePixelRatio || 1;
    canvas.width = container.clientWidth * ratio;
    canvas.height = container.clientHeight * ratio;
    ctx.scale(ratio, ratio);
    createParticles();
  }
};

const initializeCanvas = () => {
  canvas = document.getElementById("fiberCanvas");
  ctx = canvas.getContext("2d");

  resizeCanvas();
  animate();
};

onMounted(() => {
  initializeCanvas();
  window.addEventListener("resize", resizeCanvas);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeCanvas);
});
</script>

<template>
  <div ref="containerRef" class="fiber-container">
    <canvas id="fiberCanvas"></canvas>
  </div>
</template>

<style scoped>
.fiber-container {
  width: 100%;
  height: 100vh;
  background: black;
  position: relative;
  overflow: hidden;
}

canvas {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
